const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user likes component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('manageCategories', ['Application', 'Categories', '$translate', function (Application, Categories, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/manage-categories.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.activeTab = 'locations';

      self.resetCategory = function() {
        self.newCategory = {};
        self.editCategory = null;
        self.main.name = self.initialMainName;
        self.editMain = false;
        self.categoryToDelete = null;
        self.childrenToDelete = [];
        self.showCategoryDelete = false;
      };

      self.resetLocation = function() {
        self.newLocation = {};
        self.editLocation = null;
        self.addingLocation = false;
      };

      self.addLocation = function() {
        self.buttonLoading = true;
        self.newLocation.children = null;
        self.newLocation.level = null;
        self.newLocation.parent = null;
        self.newLocation.location = true;

        self.newItem(self.newLocation)
        .then(function(data) {
          self.locations.push(data);
          self.resetLocation();
          self.buttonLoading = false;
          Application.messaging.addMessage({type: 'success', text:  self.translations(['modules.notifications.location_wasCreated'],{value: data.name}), duration: 5});
        });
      };

      self.updateLocation = function(item) {
        self.buttonLoading = true;
        self.updateItem({name: item.name}, item._id)
        .then(function(data) {
          for (var i = 0; i < self.locations.length; i++) {
            if (data._id.toString() === self.locations[i]._id.toString()) {
              self.locations[i].name = data.name;
              break;
            }
          }
          self.resetLocation();
          self.buttonLoading = false;
          Application.messaging.addMessage({type: 'success', text: self.translations(['modules.notifications.location_wasUpdated'], { value: data.name }) + data.name, duration: 5});
        });
      };

      self.removeLocation = function() {
        if (!self.locationToRemove || !self.locationToRemove._id) {
          return;
        }
        var id = self.locationToRemove._id;
        self.buttonLoading = true;
        self.removeItem(id)
        .then(function(data) {
          var index;
          for (var i = 0; i < self.locations.length; i++) {
            if (id.toString() === self.locations[i]._id.toString()) {
              index = i;
              break;
            }
          }
          self.locations.splice(index, 1);
          self.locationToRemove = null;
          self.showLocationDelete = false;
          self.buttonLoading = false;
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.location_was Removed'], duration: 5});
        });
      };

      self.addMain = function() {
        self.buttonLoading = true;
        self.main.children = null;
        self.main.level = 10;
        self.main.parent = null;
        self.main.location = false;
        self.newItem(self.main)
        .then(function(data) {
          self.main = data;
          self.buttonLoading = false;
          self.initialMainName = data.name.slice(0);
          self.editMain = false;
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.category_mainWasAdded'], duration: 5});
        });
      };

      self.updateMain = function(item) {
        self.buttonLoading = true;
        self.updateItem({name: item.name}, item._id)
        .then(function(data) {
          self.main.name = data.name;
          self.initialMainName = data.name.slice(0);
          self.editMain = false;
          self.buttonLoading = false;
          Application.messaging.addMessage({type: 'success', text: self.translations(['modules.notifications.location_wasUpdated'], {value: data.name}), duration: 5});
        });
      };

      self.addCategory = function(level, parent) {
        if (typeof level !== 'number' || level < 1 || level > 3) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.category_incorrectRange'], duration: 5});
          return;
        }
        if (level > 1 && !parent || level > 1 && !self.directory[parent]) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidParent'], duration: 5});
          return;
        }
        self.buttonLoading = true;
        self.newCategory.children = [];
        self.newCategory.level = level;
        self.newCategory.parent = parent;
        self.newCategory.location = false;
        self.newItem(self.newCategory)
        .then(function(data) {
          // add to parents children
          if (level > 1 && parent) {
            self.directory[parent].children.push(data._id);
            self.updateItem({children: self.directory[parent].children}, parent)
            .then(function(data) {
              self.resetCategory();
              self.buttonLoading = false;
              self.initialize();
              Application.messaging.addMessage({type: 'success', text: self.translations(['modules.notifications.category_wasAdded'], { value: self.newCategory.name }), duration: 5});
            });
            return;
          }
          self.resetCategory();
          self.buttonLoading = false;
          self.initialize();
          Application.messaging.addMessage({type: 'success', text: self.translations(['modules.notifications.category_wasAdded'], { value: self.newCategory.name }), duration: 5});
        });
      };

      self.updateCategory = function(item) {
        self.buttonLoading = true;
        self.updateItem({name: item.name}, item._id)
        .then(function(data) {
          self.resetCategory();
          self.buttonLoading = false;
          self.initialize();
          Application.messaging.addMessage({type: 'success', text: self.translations(['modules.notifications.location_wasUpdated'], {value: data.name}), duration: 5});
        });
      };

      self.removeCategory = function(id) {
        self.buttonLoading = true;
        self.removeItem(id)
        .then(function(data) {
          self.resetCategory();
          self.buttonLoading = false;
          self.initialize();
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.category_wasRemoved'], duration: 5});
        });
      };

      self.removeCategoryModal = function(id) {
        var item = self.directory[id];
        self.categoryToDelete = id;
        self.childrenToDelete = [];
        if (item && item.children && item.children.length) {
          self.childrenToDelete = self.childrenToDelete.concat(item.children);
          angular.forEach(self.childrenToDelete, function(childId) {
            var child = self.directory[childId];
            if (child && child.children && child.children.length) {
              self.childrenToDelete = self.childrenToDelete.concat(child.children);
            }
          });
        }
        self.showCategoryDelete = true;
      };

      self.newItem = function(item) {
        return Categories.create({}, item).$promise
      };

      self.updateItem = function(item, id) {
        if (!id || typeof item !== 'object') {
          return;
        }
        return Categories.update({subresource: id}, item).$promise
      };

      self.removeItem = function(id) {
        if (!id) {
          return;
        }
        return Categories.remove({subresource: id}).$promise
      };

      self.sortCategories = function() {
        angular.forEach(self.categories, function(cat) {
          if (cat.location) {
            self.locations.push(cat);
          }
          if (cat.level === 1) {
            self.topLevel.push(cat);
          }
          if (cat.level === 10) {
            self.main = cat;
            self.initialMainName = cat.name.slice(0);
          }

          self.directory[cat._id] = cat;
        });
      };

      self.initialize = function () {
        self.main = {};
        self.topLevel = [];
        self.locations = [];
        self.directory = {};
        self.initialMainName;
        self.newCategory = {};
        self.newLocation = {};

        self.loading = true;
        Categories.find({}, function (data) {
          self.categories = data;
          self.sortCategories();
          if (!self.main.name) {
            self.editMain = true;
          }
          self.loading = false;
        }, function (error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.category_retrieveError'], duration: 5});
        });
      };

      $translate([
        'modules.notifications.invalidParent',
        'modules.notifications.category_incorrectRange',
        'modules.notifications.category_wasAdded',
        'modules.notifications.category_wasRemoved',
        'modules.notifications.category_mainWasAdded',
        'modules.notifications.category_retrieveError',
        'modules.notifications.location_wasUpdated',
        'modules.notifications.location_wasCreated',
        'modules.notifications.location_was Removed'
      ]).then(function(data){
        self.translations = data;
        self.initialize()
      });

    }],
    controllerAs: 'categories'
  };
}]);
